<template>
  <vx-card no-shadow>
    <div id="editProfileLoadingDiv" class="vs-con-loading__container">

      <div style="color: red; padding: 10px;">
        You can use following tags in your translation. Remember to use brackets as well.<br>
        [student_name] [instructor] [instructor_name]
      </div>
      

      <!-- Info -->
      <div class="vx-row">
        <div class="vx-col sm:w-full w-full mb-5">

          <div class="vx-col w-full sm:w-1/1 lg:w-1/1 mb-base" v-if="labels.length" v-for="(listItem, index) in labels" :key="index">
            <label><b>{{ listItem.label }}</b></label>
            <br>
            <textarea :name="listItem.label" class="w-full" v-model="listItem.value"></textarea>
          </div>
          
        </div>
      </div>

      

      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end">
        
        <vs-button @click="saveTranslationData" class="ml-4 mt-2">Save Translation</vs-button>
      </div>
    </div>
  </vx-card>
</template>

<script>

//import axios from "@/axios.js"
import moduleTheoryRatingEnglish from '@/store/theory-rating/moduleTheoryRatingEnglish.js'

export default {
  data() {
    return {
      data_local : {
        lang : 'da',
        type : 'theory'
      },
      labels: []
    }
  },
  methods: {
    getAllLabels() {
            
            this.$store.dispatch("translationManagement/fetchLabels", {
              lang : 'da',
              type : 'theory'
            })
                .then(res => { 
                    this.labels = res.data
                })
                .catch(err => { 
                })
    },
    saveTranslationData() {
      console.log( 'save clicked...' + this.labels[0].value );

      this.$store.dispatch("translationManagement/updateTranslation", {
        'labels' : this.labels
      })
        .then(res => { 
            this.$vs.loading.close('#editProfileLoadingDiv > .con-vs-loading')

            this.$vs.notify({
                title: "Success.",
                text: "Translations updated successfully.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success"
            });
        })
        .catch(err => { 
          if(err.status && err.status == 422){
            Object.keys(err.data).forEach(function(key) {
              self.errors.add({
                field: key,
                msg: err.data[key][0],
              });
            });
          }

          this.$vs.loading.close('#editProfileLoadingDiv > .con-vs-loading')
        })
    },

  },
  created() {
    if(!moduleTheoryRatingEnglish.isRegistered) {
      this.$store.registerModule('translationManagement', moduleTheoryRatingEnglish)
      moduleTheoryRatingEnglish.isRegistered = true
    }

    this.labels = this.$store.state.translationManagement.labels
    this.getAllLabels()

  },
  
}
</script>
